import { StateSchema } from 'app/config/storeConfig/types';
import { StepData } from 'features/Stepper';

export const getCompletedSteps = (state: StateSchema): StepData[] => state.bookingHeader.completedSteps;
